module.exports = __webpack_public_path__ + "img/fzlc-5.60ba7a30.png";